import React, { useEffect } from 'react';
import { navigate } from 'gatsby';
import { Helmet } from 'react-helmet';
import { siteUrl as SITE_URL } from '@config';
import { defaultLanguage, supportedLanguages } from '../i18n/content';
import { normalizeLanguage, STORAGE_KEY } from '../context/language';

const resolvePreferredLanguage = () => {
  if (typeof window === 'undefined') {
    return defaultLanguage;
  }

  const stored = normalizeLanguage(window.localStorage.getItem(STORAGE_KEY));
  if (stored && supportedLanguages.includes(stored)) {
    return stored;
  }

  const browserCandidates = [window.navigator.language, ...(window.navigator.languages || [])];

  for (const candidate of browserCandidates) {
    const normalized = normalizeLanguage(candidate);
    if (normalized && supportedLanguages.includes(normalized)) {
      return normalized;
    }
  }

  return defaultLanguage;
};

const IndexPage = () => {
  useEffect(() => {
    const preferredLanguage = resolvePreferredLanguage();
    navigate(`/${preferredLanguage}`, { replace: true });
  }, []);

  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>Redirecting | Hedi Hidouri</title>
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href={`${SITE_URL}/en`} />
        <link rel="alternate" hrefLang="en" href={`${SITE_URL}/en`} />
        <link rel="alternate" hrefLang="fr" href={`${SITE_URL}/fr`} />
        <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}/`} />
      </Helmet>

      <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <p>Redirecting...</p>
      </main>
    </>
  );
};

export default IndexPage;
